/* eslint-disable camelcase */
import notifications from 'api/notifications'
import { camelize } from 'helpers/camelCase'

export async function getServiceProgressMessages(serviceId) {
    return notifications
        .get('service/progress',{ service_id:serviceId,})
        .then((response) => camelize(response.data[0]))
}
